import { render, staticRenderFns } from "./stock-detail.vue?vue&type=template&id=17bf3948&scoped=true&"
import script from "./stock-detail.vue?vue&type=script&lang=js&"
export * from "./stock-detail.vue?vue&type=script&lang=js&"
import style0 from "./stock-detail.styl?vue&type=style&index=0&id=17bf3948&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bf3948",
  null
  
)

export default component.exports